import React, { useState } from "react";
import Swal from "sweetalert2";
import "./formThree.css";
import { useNavigate } from "react-router-dom";

const FormThree = (props) => {
  const navigate = useNavigate();
  const [userThree] = useState(props.userform);
  console.log(userThree.UserRegistration.infoUser);

  const [UserInfo, setUserInfo] = useState({
    Nombre_Apellido:
      userThree?.UserRegistration?.infoUser?.Apellidoynombres || "",
    DNI: userThree?.UserRegistration?.infoUser?.NumeroDocumento || "",
    Cuil: userThree?.UserRegistration?.infoUser?.Cuil || "",
    Domicilio_Completo_empleador:
      userThree?.UserRegistration?.infoUser?.LaboralCalle || "",
    Razon_Social: userThree?.UserRegistration?.infoUser?.Reparticion || "",
    Calle: userThree?.UserRegistration?.infoUser?.Calle || "",
    Numero: userThree?.UserRegistration?.infoUser?.Nro || "",
    Departamento: (
      userThree?.UserRegistration?.infoUser?.Departamento || ""
    ).trim(),
    Piso: (userThree?.UserRegistration?.infoUser?.Piso || "").trim(),
    Localidad: userThree?.UserRegistration?.infoUser?.Localidad || "",
    Codigo_postal: userThree?.UserRegistration?.infoUser?.CodigoPostal || "",
    Numero_Celular_Fijo:
      (userThree?.UserRegistration?.infoUser?.PrefTeleCelular || "") +
      (userThree?.UserRegistration?.infoUser?.TeleCelular || ""),
    CBU: userThree?.UserRegistration?.infoUser?.CBU || "",
    Email: userThree?.UserRegistration?.infoUser?.Email || "",
  });

  const [ID] = useState({
    id: userThree.UserRegistration.infoUser.id || undefined,
  });
  const [errorForm, setErrorForm] = useState();

  const clickPartFour = () => {
    const userPass3 = {
      UserRegistration: {
        credito: { ...userThree.UserRegistration.credito },
        newID: userThree.UserRegistration.newID,
        id: ID,
        infoUser: { ...UserInfo },
      },
    };

    let formIsValid = true;

    const userInfo = UserInfo; // Simplifica el acceso a UserInfo

    // Expresión regular para verificar el formato del correo electrónico y los dominios permitidos
    const emailRegex = /^[^\s@]+@(hotmail|gmail|outlook)\.[^\s@]+$/i;

    if (
      userInfo.Nombre_Apellido.length < 4 ||
      userInfo.DNI.length !== 8 || // DNI debe tener 8 dígitos exactos
      userInfo.Cuil.length !== 11 || // CUIL debe tener 11 dígitos exactos
      userInfo.Domicilio_Completo_empleador.length < 4 ||
      userInfo.Razon_Social.length < 4 ||
      userInfo.Calle.length < 4 ||
      userInfo.Numero < 0 || // Corregido: debe ser > 0 si es positivo
      userInfo.Localidad.length < 4 ||
      userInfo.Codigo_postal.length < 2 ||
      userInfo.Numero_Celular_Fijo.length < 6 ||
      userInfo.CBU.length < 22 ||
      !emailRegex.test(userInfo.Email) // Verificar correo electrónico y dominios permitidos
    ) {
      formIsValid = false;
      if (!emailRegex.test(userInfo.Email)) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El formato del correo electrónico no es válido o no es de un dominio permitido (hotmail, gmail, outlook).",
        });
      } else if (userInfo.DNI.length !== 8) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El DNI debe tener exactamente 8 dígitos.",
        });
      } else if (userInfo.Cuil.length !== 11) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El CUIL debe tener exactamente 11 dígitos.",
        });
      }
    }

    setErrorForm(!formIsValid);

    if (formIsValid) {
      navigate("/Ingresar_Info", { state: userPass3 });
    }
  };

  return (
    <div className="formThree">
      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-user icon"></i>
            <input
              className="inputForm"
              placeholder="Nombre y Apellido"
              value={UserInfo.Nombre_Apellido}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Nombre_Apellido: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Nombre_Apellido?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-regular fa-address-card icon"></i>
            <input
              className="inputForm"
              placeholder="DNI"
              value={UserInfo.DNI}
              maxLength={8}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, DNI: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.DNI?.length < 7 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-id-badge icon"></i>
            <input
              className="inputForm"
              placeholder="Cuil"
              value={UserInfo.Cuil}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Cuil: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Cuil?.length < 11 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>

        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-house-user icon"></i>
            <input
              className="inputForm"
              placeholder="Domicilio Completo / Empleador"
              value={UserInfo.Domicilio_Completo_empleador}
              onChange={(e) => {
                setUserInfo({
                  ...UserInfo,
                  Domicilio_Completo_empleador: e.target.value,
                });
              }}
            />
          </div>
          {errorForm && UserInfo.Domicilio_Completo_empleador?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-people-arrows icon"></i>
            <input
              className="inputForm"
              placeholder="Razon Social"
              value={UserInfo.Razon_Social}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Razon_Social: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Razon_Social?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>

        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-road icon"></i>
            <input
              className="inputForm"
              placeholder="Calle"
              value={UserInfo.Calle}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Calle: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Calle?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-list-ol icon"></i>
            <input
              className="inputForm"
              placeholder="Numero"
              value={UserInfo.Numero}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Numero: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Numero?.length < 0 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>

        <div className="boxInput2">
          <i className="fa-sharp fa-solid fa-building icon"></i>
          <input
            className="inputForm"
            placeholder="Departamento"
            value={UserInfo.Departamento}
            onChange={(e) => {
              setUserInfo({ ...UserInfo, Departamento: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="boxflex">
        <div className="boxInput2">
          <i className="fa-solid fa-building-user icon"></i>
          <input
            className="inputForm"
            placeholder="Piso"
            value={UserInfo.Piso}
            onChange={(e) => {
              setUserInfo({ ...UserInfo, Piso: e.target.value });
            }}
          />
        </div>

        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-sharp fa-solid fa-location-dot icon"></i>
            <input
              className="inputForm"
              placeholder="Localidad"
              value={UserInfo.Localidad}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Localidad: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Localidad?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-phone icon"></i>
            <input
              className="inputForm"
              placeholder="Numero de Celular / Fijo"
              value={UserInfo.Numero_Celular_Fijo}
              onChange={(e) => {
                setUserInfo({
                  ...UserInfo,
                  Numero_Celular_Fijo: e.target.value,
                });
              }}
            />
          </div>
          {errorForm && UserInfo.Numero_Celular_Fijo?.length < 6 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>

        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-building-columns icon"></i>
            <input
              className="inputForm"
              placeholder="CBU"
              value={UserInfo.CBU}
              maxLength={22}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, CBU: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.CBU?.length < 22 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxflex">
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-envelopes-bulk icon"></i>
            <input
              className="inputForm"
              placeholder="Correo Electronico"
              value={UserInfo.Email}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Email: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Email?.length < 4 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
        <div className="boxinputanderror">
          <div className="boxInput2">
            <i className="fa-solid fa-envelopes-bulk icon"></i>
            <input
              className="inputForm"
              placeholder="Codigo Postal"
              value={UserInfo.Codigo_postal}
              onChange={(e) => {
                setUserInfo({ ...UserInfo, Codigo_postal: e.target.value });
              }}
            />
          </div>
          {errorForm && UserInfo.Codigo_postal?.length < 2 ? (
            <p className="errorMesage">Por favor llene el campo</p>
          ) : null}
        </div>
      </div>

      <div className="boxButton">
        <button onClick={clickPartFour} className="Button">
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default FormThree;
